import React from "react";
import DOMPurify from "dompurify";
import HeaderPublico from "../../components/HeaderPublico";
import FooterPublico from "../../components/FooterPublico";
import LegalBackLink from "../../components/LegalBackLink";
import useLegalPageContent from "../../hooks/useLegalPageContent";
import "./Terminos.css";

function PrivacidadFallbackContent() {
  return (
    <>
      <section>
        <h2>1. Responsable del tratamiento</h2>
        <p>El responsable del tratamiento de sus datos personales es el titular indicado en contacto.</p>
      </section>
      <section>
        <h2>2. Datos que recogemos</h2>
        <p>
          Recogemos los datos necesarios para el registro y la gestión de pagos. No recogemos más
          datos de los estrictamente necesarios para prestar el servicio.
        </p>
      </section>
    </>
  );
}

export default function Privacidad() {
  const { contentHtml, updatedLabel, loading } = useLegalPageContent("privacidad");
  const sanitizedHtml = contentHtml.trim()
    ? DOMPurify.sanitize(contentHtml)
    : "";

  return (
    <div className="pagina-publicitaria">
      <HeaderPublico cursos={[]} />
      <div className="legal-content">
        <h1>Política de Privacidad</h1>
        <p className="legal-updated">{updatedLabel || "Última actualización: Febrero 2026 (v1)"}</p>

        {loading ? <p>Cargando…</p> : null}
        {!loading && sanitizedHtml ? (
          <div
            className="legal-content-body"
            dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
          />
        ) : null}
        {!loading && !sanitizedHtml ? <PrivacidadFallbackContent /> : null}

        <p className="legal-back">
          <LegalBackLink />
        </p>
      </div>
      <FooterPublico />
    </div>
  );
}
